import { css } from 'styled-components';

export const BorderBottomStyle = css`
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 6px;
  &.border-type-thin {
    text-decoration-thickness: 1px;
  }
`;
